///<reference path="../short-cuts/models/maintenance-short-cuts.controller.ts"/>

module Meevo.Components.BaseClasses {

    import MaintenanceShortCutsController = Meevo.Components.ShortCuts.MaintenanceShortCutsController;
    import ICustomDataContextConfig = Meevo.Model.ICustomDataContextConfig;

    interface ICustomDataControllerConfig {
        use: boolean,
        udfNoun?: Meevo.Model.NounEnum,
        appAreaEnum: Meevo.Model.AppAreaEnum
    }

    export abstract class DataMaintenanceControllerBase extends MaintenanceShortCutsController<IDataMaintenanceSection<any>, IDataMaintenanceContext> implements IDataMaintenanceController {
        protected selectedItemId: Guid;
        protected preValidationPromise: ng.IPromise<boolean> = null;
        protected asLocationId: number;
        protected context: IDataMaintenanceContext;
        protected searchContext: any;
        protected searchContextCriteria: any;
        protected visualState: Model.MaintenanceFormVisualState;
        protected initialEditSection: string;
        protected initialEditSubSection: string;
        protected targetView: any;
        protected searchFallbackCriteria: any;
        protected customDataControllerConfig: ICustomDataControllerConfig;
        public customDataContextConfig: ICustomDataContextConfig = null;

        protected meevoSecurityKeys = Meevo.Components.Common.SecurityKeys;
        public atLocationIdWatcher = null;
        /**
         * The state/route/context name associated with this controller
         * It is derived from the current state that is active when the controller is instantiated.
         * If the child class doesn't supply $state to this base constructor, then this is never populated.
         */
        protected associatedStateName: string = '';

        constructor(protected appSettings: Meevo.Components.Common.IAppSettings,
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected identityService: Meevo.Components.Common.IIdentityService,
            protected loggingService: Meevo.Components.Logging.ILoggingService,
            protected $scope: angular.IScope,
            protected contextParams: IContextParams,
            protected $state: any,
            protected $rootScope: angular.IRootScopeService,
            protected shortCutsService: Meevo.Components.ShortCuts.IShortCutsService,
            customDataControllerConfig?: ICustomDataControllerConfig
        ) {
            super($scope, $state, shortCutsService);

            /********************************************************************************
             * State/route/context monitoring
             * 1. Get the state/route name associated with this controller
             * 2. Hook the state change success listener to the handlers
             ********************************************************************************/
            // If $state is passed in by the child, we assign a local member to hold the state name.
            // The $state.current property holds the current state name that is active as this constructor runs
            // so we take that to be the state associated with this controller for active/inactive purposes.
            if (!_.isEmpty($state)) {
                this.associatedStateName = $state.current.name;
            }

            //// Apply state params if they are present.
            //if (!_.isEmpty(contextParams.params)) {
            this.applyParams(this.contextParams.params);
            //}

            // Hook the listener to $rootScope, if it is available
            if (!_.isEmpty($scope)) {
                $scope.$on('$stateChangeSuccess',
                    (event, toState, toParams, fromState, fromParams) => {
                        if (fromState.name === this.associatedStateName) {
                            this.onRouteInactive();
                        } else if (toState.name === this.associatedStateName) {
                            this.onRouteActive();
                            //  Prevent Access To SelectedSection If Unauthorized User Logs In Thru MeevoLockout Feature
                            let hasSelectedSection = (<any>this.context || {}).selectedSection || null;
                            let hasAccessToSelectedSection = !!hasSelectedSection && (!this.context.selectedSection.sectionSecurityKey || (<any>this.context).securityChecker.hasSecurity(this.context.selectedSection.sectionSecurityKey));
                            if (!hasAccessToSelectedSection && Model.Guard.isSomething(this.selectedItemId)) {
                                if ((<any>this.context).navigationBlocked) {
                                    this.modalService.alert('Oops ... you are not supposed to be here. Please click cancel to discard changes and move to another screen')
                                } else {
                                    let index = _.findIndex(this.context.sections, (s: any) => s.sectionSecurityKey ? (<any>this.context).securityChecker.hasSecurity(s.sectionSecurityKey) : true);
                                    this.context.selectedSection = this.context.sections[index] || this.context.selectedSection
                                    let hasModel = this.context.selectedSection.model || (<any>this.context).reloadSelectedSection();   //  reloadSelectedSection Only If this.selectedItemId && !this.context.selectedSection.model
                                }
                            }
                        }
                    });

                $scope.$on(Meevo.Components.Common.Messages.SET_MAINTENANCE_FORM_STATE, (event, params) => {
                    if (params
                        && params.data
                        && params.data.stateParams
                        && params.data.stateName === this.associatedStateName
                        && this.context
                        && this.context.selectedSection
                        && this.context.selectedSection.isInteropContext
                        && this.context.selectedSection.displayNameContentKey == params.data.stateParams.initialEditSection) {
                        this.context.selectedSection.mode = params.data.stateParams.mode;
                    }
                });
            }
            // Run onRouteActive here since this also counts as entering this state (and the stateChangeSuccess message has already happened for this first load
            this.onRouteActive();

            this.customDataControllerConfig = customDataControllerConfig;
            if (this.customDataControllerConfig && this.customDataControllerConfig.use) {
                this.getCustomDataInfo()
                    .then(() => this.addWatchers());
            } else {
                this.addWatchers();
            }

            /**
             * Subscribes to the ApplyParamsToContext message which will
             * take the params received and take the necessary action on the current context.
             */
            $scope.$on(Meevo.Components.Common.Messages.APPLY_PARAMS_TO_CONTEXT,
                (event, state, params) => {
                    if (state.name === this.associatedStateName) {
                        this.applyParams(params);
                    }
                });
        }

        /**
         * Get custom tabs list for specific app area and business type
         * */
        private getCustomDataInfo(): ng.IPromise<any> {

            return this.dataService.getListPaged('CustomData/Tab', {
                criteria: {
                    objectStateEnums: [Meevo.Model.ObjectStateEnum.Active],
                    appAreaEnum: this.customDataControllerConfig.appAreaEnum,
                    businessType_TId: this.identityService.businessTypeId
                }
            })
                .then((data: any) => {
                    this.customDataContextConfig = {
                        use: this.customDataControllerConfig.use,
                        udfNoun: this.customDataControllerConfig.udfNoun,
                        appAreaEnum: this.customDataControllerConfig.appAreaEnum,
                        appAreaTabs: data[this.customDataControllerConfig.appAreaEnum],
                        $controllersScope: this.$scope
                    };
                });
        }

        /**
         * Add watchers to $scope
         * */
        private addWatchers(): void {
            /**
             * Handles changing of the VisualState from the search page to the detail page.
             * @return {}
             */
            this.$scope.$watch(() => this.visualState, (newState: Model.MaintenanceFormVisualState) => {
                if (newState === Model.MaintenanceFormVisualState.Detail && this.selectedItemId == null) {
                    this.createContext();
                }

                if (newState === Model.MaintenanceFormVisualState.Detail) {
                    this.bindHotkeys();
                }

                if (newState === Model.MaintenanceFormVisualState.Search) {
                    this.selectedItemId = null;
                    this.cleanup();
                }
            });

            /**
             * Handles creating a context for an item when the selectedItemId changes
             * *AND* we are in the Detail state.  This will happen if the user
             * chooses an item from the 'Search Results' dropdown that is available
             * on the 'Detail' screen.
             * @return {}
             */
           this.$scope.$watch(() => this.selectedItemId, (newItemId: Guid) => {
                if (this.visualState === Model.MaintenanceFormVisualState.Detail && this.selectedItemId != null) {
                    this.createContext();
                }
            });

            /**
             * Handles creating a context for an item when the initialEditSection (TABs) changes
             * *AND* we are in the Detail state.
             * @return {}
             */
            //this.$scope.$watch(() => this.initialEditSection, (newInitialEditSection: any) => {
            //    if (this.visualState === Model.MaintenanceFormVisualState.Detail && this.initialEditSection) {
            //        this.createContext();
            //    }
            //});

            /**
             * Handles changing of the VisualState from the search page to the detail page.
             * @return {}
             */
            //$scope.$watch(() => this.asLocationId, (newAsLocation: number) => {
            //    if (this.visualState === Model.MaintenanceFormVisualState.Detail && this.selectedItemId != null && newAsLocation != null) {
            //        this.createContext();
            //    }
            //});
        }

        /**
         * Determines whether or not to showSearch in a format that is usable by the
         * UI (Can't get enum evaluation to work in UI)
         * @return {boolean}
         */
        get showSearch(): boolean {
            return this.visualState === Model.MaintenanceFormVisualState.Search;
        }

        /**
         * Function which handles creation of the context for the matainenance form,
         * activation, and additional initialization.
         * @return {}
         */
        public createContext(): void {
            this.context.closeCallback = this.processCallback;
            if (this.identityService.inCentralOfficeMode()) {
                if (!this.atLocationIdWatcher) {
                    this.atLocationIdWatcher = this.$scope.$watch(() => this.context.atLocationId, (newAtLocationId: number) => {
                        if (this.visualState === Model.MaintenanceFormVisualState.Detail && this.selectedItemId != null && newAtLocationId != null) {
                            this.asLocationId = newAtLocationId;
                        }
                    });
                }
            }
        };

        public cleanup(): void {
            if (this.context) {
                this.context.cleanup();
            }
        }

        /**
         * Handles processing a call back if one was supplied in the contextParams.
         * this will enable other areas to navigate to the client, and then redirect
         * back to themselves upon an event (i.e. postAdd, postUpdate, postCancel...)
         * @return{}
         */
        protected processCallback = (model: any, executeCallback: boolean, fromCancel?: boolean) => {
            var cb = Model.Guard.isSomething(this.contextParams) ? this.contextParams.params : null; //this may be overwritten during closecontext, so cache it temporarily here.
            if (cb && cb.callback) {
                this.$rootScope.$broadcast('closeContext', this.$state.current, cb.callbackState);
                if (executeCallback && cb.callback) {
                    let modelToSend = model;
                    if (fromCancel
                        && !(cb.redirectFromDupe && cb.typeaheadMode == Meevo.Model.TypeaheadMode.Add)) {
                        //  Do not send model if it is from cancel and redirectFromDupe is true
                        modelToSend = null;
                    }
                    if (Model.Guard.isSomething(cb.callbackController) && cb.callbackController) {
                        cb.callback({ model: modelToSend, callbackData: cb.callbackData, callbackContext: cb });
                    }
                    else {
                        cb.callback(modelToSend, cb);
                    }
                }
            }
        }

        /**
         * Should be overridden when necessary to validate the 'incoming' entity id
         * @return{}
         */
        public preValidation(id): ng.IPromise<boolean> {
            return null;
        }

        /**
         * Initializes the visual state based on the presence of params.
         * @param params
         */
        public async applyParams(params) {
            if (!_.isEmpty(params) && params.targetState != null) {
                this.contextParams.params = params;
                if (params.actionState != null) {
                    if (params.actionState === Model.MaintenanceFormState.Editing || (params.actionState === Model.MaintenanceFormState.Readonly && params.id)) {
                        // check pre validation before setting the id
                        var promise = this.preValidation(params.id);
                        if (promise != null) {
                            await new Promise(resolve =>
                                promise.then((result) => {
                                    if (result) {
                                        this.selectedItemId = params.id;
                                        this.initialEditSection = params.initialEditSection;
                                        this.initialEditSubSection = params.initialEditSubSection;
                                        this.visualState = params.targetState;
                                    }
                                    else {
                                        this.selectedItemId = null;
                                        this.visualState = Model.MaintenanceFormVisualState.Search;
                                    }
                                    resolve();
                                })
                            );
                        }
                        else {
                            this.selectedItemId = params.id;
                            this.initialEditSection = params.initialEditSection;
                            this.initialEditSubSection = params.initialEditSubSection;
                            this.visualState = params.targetState;
                        }
                    }
                    else if (params.actionState === Model.MaintenanceFormState.Adding) {
                        this.selectedItemId = null;
                        this.visualState = params.targetState;
                    }
                }
                else {
                    this.selectedItemId = null;
                    this.visualState = params.targetState;
                }
            }
            else {
                this.selectedItemId = null;
                this.visualState = Model.MaintenanceFormVisualState.Search;
            }
        }

        /**
         * Runs when this route becomes active, either due to initial creation
         * or by being navigated to as a sticky state
         */
        onRouteActive() {
        }

        /**
         * Runs when the route becomes inactive (i.e. another route is navigated to
         * from this one.
         */
        onRouteInactive() {
            if (this.atLocationIdWatcher) {
                this.atLocationIdWatcher();
            }
        }

        public getContext(): IDataMaintenanceContext {
            return this.context;
        }

        public isSingleLocation(): boolean {
            if (Model.Guard.isSomething(this.identityService.current().isSingleLocation))
                return this.identityService.current().isSingleLocation;
            else
                return false;
        }
    }
}